import { ticoticketApi } from "../ticoticketApi";
import Cookies from "js-cookie";

interface UpdatedFields {
  name?: string;
  email?: string;
  phoneNumber?: string;
  dateOfBirth?: string;
}

interface PasswordFields {
  oldPassword?: string;
  newPassword?: string;
}

export const getUserData = async () => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get("/user/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateUserData = async (updatedFields: UpdatedFields) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.put("/user/me", updatedFields, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateUserPassword = async (passwordFields: PasswordFields) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.put("/user/password", passwordFields, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const getUserTotalTicketsSummary = async () => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get("/user/summary/purchases", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const getUserTickets = async () => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get("/user/tickets", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(data);

    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};
